import { Controller } from "@hotwired/stimulus";
import { flashAlert } from "../../components/flash_alert";
import { closeModal, parentModal, sortByCustomFunction } from "../../utils/misc";

export default class extends Controller {
  static targets = ["pageNumber", "invoiceContainer"];
  static values = { numberOfDocumentsToVerify: Number };

  documentValidated(event) {
    const response = event.detail[0];
    this._dispatchDocumentValidatedEvent(response);

    if (this.numberOfDocumentsToVerifyValue > 1) {
      this._manageDocumentsDisplay();
    } else {
      this._allDocumentsVerified();
    }

    flashAlert(this.element.dataset.documentValidatedSuccessMessage);
  }

  _dispatchDocumentValidatedEvent(response) {
    document.dispatchEvent(new CustomEvent("accountingDocument:validated", { detail: response }));
  }

  documentRemoved(event) {
    const response = event.detail[0];
    this._dispatchDocumentRemovedEvent(response);

    if (this.numberOfDocumentsToVerifyValue > 1) {
      this._removeCurrentDocument(response.accounting_document_id);

      this._manageDocumentsDisplay();
    } else {
      this._allDocumentsVerified();
    }

    flashAlert(this.element.dataset.documentRemovedSuccessMessage);
  }

  _dispatchDocumentRemovedEvent(response) {
    document.dispatchEvent(new CustomEvent("accountingDocument:removed", { detail: response }));
  }

  _removeCurrentDocument(deletedAccountingDocumentId) {
    const documentToDelete = this.invoiceContainerTargets.find(
      (target) => parseInt(target.dataset.accountingDocumentId) === deletedAccountingDocumentId
    );
    documentToDelete.remove();
  }

  _manageDocumentsDisplay() {
    const currentPageNumber = this.pageNumberTargets.find((target) => target.classList.contains("active-page"));
    currentPageNumber.classList.add("document-verified");

    const unverifiedPages = this.pageNumberTargets.filter((target) => !target.classList.contains("document-verified"));
    const nextPageNumbers = sortByCustomFunction(unverifiedPages, (target) => parseInt(target.dataset.id));
    nextPageNumbers[0].click();

    this.numberOfDocumentsToVerifyValue--;
  }

  _allDocumentsVerified() {
    const modalId = parentModal(this.element).id;
    closeModal(modalId);
  }
}
